import { gql } from "@apollo/client";

export const registerJudgeMutation = gql`
  mutation RegisterJudge($data: RegisterJudgeInput!) {
    registerJudge(data: $data) {
      success
      message
    }
  }
`;

export const getMyMembeJudgeProfileQuery = gql`
  query GetMyMembeJudgeProfile {
    getMyMemberProfile {
      id
      first_name
      last_name
      email
      location_address
      phone_number
      authId
      distance_travel
      role
      state
      city
      zipCode
      timezone
    }
  }
`;
